import { render, staticRenderFns } from "./TailwindSelect.vue?vue&type=template&id=23dbab00&scoped=true&"
import script from "./TailwindSelect.vue?vue&type=script&lang=js&"
export * from "./TailwindSelect.vue?vue&type=script&lang=js&"
import style0 from "./TailwindSelect.vue?vue&type=style&index=0&id=23dbab00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dbab00",
  null
  
)

export default component.exports